module.exports = __webpack_public_path__ + "static/img/LOGO.9107408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF97/LOGO.png
// module id = i0SK
// module chunks = 0